import script from "./UserAssignment.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAssignment.vue?vue&type=script&setup=true&lang=ts"

import "./UserAssignment.vue?vue&type=style&index=0&id=95ba1a52&scoped=true&lang=scss"
import "./UserAssignment.vue?vue&type=style&index=1&id=95ba1a52&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95ba1a52"]])

export default __exports__